import { Link, Outlet, useLocation } from "react-router";
import { SignedIn, SignedOut, RedirectToSignIn, UserButton } from "@clerk/clerk-react";
import { Plane, LayoutDashboard, Key, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/keys", label: "API Keys", icon: Key },
  { to: "/docs", label: "API Docs", icon: BookOpen },
];

const AppLayout = () => {
  const location = useLocation();

  return (
    <>
      <SignedIn>
        <div className="min-h-screen bg-background">
          <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container mx-auto flex h-14 items-center justify-between px-4 sm:px-6 lg:px-8">
              <Link to="/dashboard" className="flex items-center gap-2">
                <Plane className="h-5 w-5" />
                <span className="text-xl font-bold tracking-tight">Travel API</span>
              </Link>

              <nav className="hidden md:flex items-center gap-1">
                {navItems.map((item) => (
                  <Button
                    key={item.to}
                    variant="ghost"
                    size="sm"
                    asChild
                    className={cn(
                      location.pathname === item.to && "bg-accent text-accent-foreground"
                    )}
                  >
                    <Link to={item.to}>
                      <item.icon className="h-4 w-4" />
                      {item.label}
                    </Link>
                  </Button>
                ))}
              </nav>

              <UserButton
                appearance={{
                  elements: {
                    avatarBox: "size-8",
                  },
                }}
              />
            </div>
          </header>

          {/* Mobile nav */}
          <nav className="md:hidden border-b bg-background px-4 py-2 flex gap-1 overflow-x-auto">
            {navItems.map((item) => (
              <Button
                key={item.to}
                variant="ghost"
                size="sm"
                asChild
                className={cn(
                  "flex-shrink-0",
                  location.pathname === item.to && "bg-accent text-accent-foreground"
                )}
              >
                <Link to={item.to}>
                  <item.icon className="h-4 w-4" />
                  {item.label}
                </Link>
              </Button>
            ))}
          </nav>

          <main className="container mx-auto px-4 py-6 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
            <Outlet />
          </main>

          <Toaster position="bottom-right" />
        </div>
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
};

export default AppLayout;
